import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState, Fragment } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";

type MenuPopupProps = {
  disasterId: number;
};

export default function MenuPopup({ disasterId }: MenuPopupProps) {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Button
        variant="contained"
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ pointerEvents: "auto" }}
        endIcon={<KeyboardArrowDownIcon />}
        aria-label="操作選択"
      >
        操作選択
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        aria-label="操作選択メニュー"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <MenuItem
          onClick={() =>
            handleNavigate(`/dashboard/disastermap?disaster-id=${disasterId}`)
          }
          value="click_map"
          sx={{ fontWeight: "bold" }}
          aria-label="マップ表示"
        >
          マップ表示
        </MenuItem>
        <MenuItem
          onClick={() =>
            handleNavigate(`/dashboard/sslist?disaster-id=${disasterId}`)
          }
          value="click_map"
          sx={{ fontWeight: "bold" }}
          aria-label="対象SS一覧"
        >
          対象SS一覧
        </MenuItem>
        <MenuItem
          onClick={() =>
            handleNavigate(
              `/dashboard/situationcheck?disaster-id=${disasterId}`
            )
          }
          value="click_map"
          sx={{ fontWeight: "bold" }}
          aria-label="被害状況確認"
        >
          被害状況確認
        </MenuItem>
        <MenuItem
          onClick={() =>
            handleNavigate(`/dashboard/totalization?disaster-id=${disasterId}`)
          }
          value="click_map"
          sx={{ fontWeight: "bold" }}
          aria-label="集計表"
        >
          集計表
        </MenuItem>
      </Menu>
    </Fragment>
  );
}
